import { render, staticRenderFns } from "./SwitchAutomatorEditorModal.vue?vue&type=template&id=6ca17165&scoped=true&"
import script from "./SwitchAutomatorEditorModal.vue?vue&type=script&lang=js&"
export * from "./SwitchAutomatorEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAutomatorEditorModal.vue?vue&type=style&index=0&id=6ca17165&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca17165",
  null
  
)

export default component.exports